/* eslint-disable react/require-default-props */

import React from 'react';

const HeaderStocksInfoContainer = (props) => (
  <div className="stocks-info-bar">
    <div className="scroll-bar">
      <div className="scroll-content">{props.children}</div>
    </div>
  </div>
);

export default HeaderStocksInfoContainer;
